import request from '@/utils/request'

export function getChannelList(data) {
  return request({
    url: '/Api/brand.Channel/index',
    method: 'post',
    data
  })
}

export function delChannel(data) {
  return request({
    url: '/Api/brand.Channel/delChannel',
    method: 'post',
    data
  })
}

export function getBillBaseInfo(data) {
  return request({
    url: '/Api/brand.ChannelDaliybill/getBaseInfo',
    method: 'post',
    data
  })
}

export function addBill(data) {
  return request({
    url: '/Api/brand.ChannelDaliybill/addBill',
    method: 'post',
    data
  })
}

export function addOrEdit(data) {
  return request({
    url: '/Api/brand.Channel/addOrEdit',
    method: 'post',
    data
  })
}

export function basicInfo(data) {
  return request({
    url: '/Api/brand.Channel/basicInfo',
    method: 'post',
    data
  })
}

//渠道销售数据列表
export function ChannelDetail(data) {
  return request({
    url: '/Api/brand.ChannelDaliybill/ChannelDetail',
    method: 'post',
    data
  })
}

//删除渠道销售数据
export function delChannelData(data) {
  return request({
    url: '/Api/brand.ChannelDaliybill/delChannelData',
    method: 'post',
    data
  })
}